import gql from 'graphql-tag'
import { useQuery } from '@apollo/react-hooks'

export const MFA_STATUS_QUERY = gql`
  query app__MfaStatus {
    mfaStatus {
      userId
      totpEnabled
      smsEnabled
      lastFourPhone
    }
  }
`

interface MfaStatusQuery {
  mfaStatus: MfaStatusPayload | null
}

interface MfaStatusPayload {
  userId: string | null
  totpEnabled: boolean | null
  smsEnabled: boolean | null
  lastFourPhone: string | null
}

interface MfaStatusResult {
  isLoading: boolean
  isErrored: boolean
  isEnabled: boolean
  isTotpEnabled: boolean
  isSmsEnabled: boolean
  lastFourPhone: string | null
  refetchMfaStatus: ReturnType<typeof useQuery>['refetch']
}

export function useMfaStatus(): MfaStatusResult {
  const { data, error, loading, refetch } = useQuery<MfaStatusQuery>(MFA_STATUS_QUERY)
  const mfaStatus = data ? data.mfaStatus : null
  const isTotpEnabled = Boolean(mfaStatus && mfaStatus.totpEnabled)
  const isSmsEnabled = Boolean(mfaStatus && mfaStatus.smsEnabled)
  const isEnabled = isTotpEnabled || isSmsEnabled

  return {
    isLoading: loading,
    isErrored: Boolean(error),
    isEnabled,
    isTotpEnabled,
    isSmsEnabled,
    lastFourPhone: mfaStatus && mfaStatus.lastFourPhone,
    refetchMfaStatus: refetch
  }
}
